// see https://player.support.brightcove.com/plugins/thumbnails-plugin.html for details
type ThumbnailSource = {
  kind: 'metadata';
  label: 'thumbnails';
  mode: 'hidden';
  src: string;
};

export function extractThumbnailsSource(details: any): ThumbnailSource | null {
  const textTracks = details?.text_tracks;
  if (!Array.isArray(textTracks)) {
    return null;
  }
  const thumbnail = textTracks.find(item => {
    const { kind, label } = item;
    return kind === 'metadata' && label === 'thumbnails';
  });

  if (typeof thumbnail === 'undefined') {
    return null;
  }

  return {
    kind: 'metadata',
    label: 'thumbnails',
    mode: 'hidden',
    src: thumbnail.src,
  };
}
